export default __webpack_public_path__ + "static/media/gaurav2.206c3908.jpg";